import { useSocketEvent, useSocketState } from '../helpers/useSocket'
import React, { useState } from 'react'

import '../BracketDisplay.css'
import { SingleEliminationBracket } from 'react-tournament-brackets'
import { Match } from '../components/Bracket/BracketSetDisplay'

//ChatGPT 5.0 - https://chatgpt.com/c/694d890e-00ac-8331-b931-0a06ab7d28b1
function generateSingleElimSkeleton(numSeeds) {
	const totalRounds = Math.log2(numSeeds)

	const matches = []
	let matchId = 1

	// Track where each round starts
	const roundStartIndex = []

	let matchesInRound = numSeeds / 2

	for (let round = 1; round <= totalRounds; round++) {
		roundStartIndex[round] = matchId

		for (let i = 0; i < matchesInRound; i++) {
			matches.push({
				id: matchId,
				round,
				name: `Match ${matchId}`,
				tournamentRoundText: `${round}`,
				nextMatchId: null,
				participants: [
					{ id: null, name: 'TBD', resultText: '-' },
					{ id: null, name: 'TBD', resultText: '-' },
				],
			})

			matchId++
		}

		matchesInRound /= 2
	}

	// Now wire nextMatchId correctly
	for (let round = 1; round < totalRounds; round++) {
		const currentRoundStart = roundStartIndex[round]
		const nextRoundStart = roundStartIndex[round + 1]

		const matchesInRound =
			roundStartIndex[round + 1] - roundStartIndex[round]

		for (let i = 0; i < matchesInRound; i++) {
			const match = matches[currentRoundStart - 1 + i]
			const nextMatch = matches[nextRoundStart - 1 + Math.floor(i / 2)]

			match.nextMatchId = nextMatch.id
		}
	}

	return matches
}

function mergeRealMatches(skeleton, realSets) {
	if (!realSets) return null
	let roundIndex = {}

	skeleton.forEach((m) => {
		if (!roundIndex[m.round]) roundIndex[m.round] = []
		roundIndex[m.round].push(m)
	})

	realSets.forEach((set) => {
		const target = roundIndex[set.round]?.find(
			(m) => m.participants[0].id === null,
		)

		if (!target) return

		target.participants = set.slots.map((slot) =>
			slot.entrant
				? {
						id: slot.entrant.id,
						name: slot.entrant.name,
						resultText: String(slot.entrant.score) || '0',
					}
				: { id: '-1', name: 'TBD', resultText: '-' },
		)
	})

	return skeleton
}

function BracketDisplay() {
	const [tournament] = useSocketState('Tournament')
	const [config, setConfig] = useState({ cssTheme: 'default.css' })

	const skeleton = generateSingleElimSkeleton(
		tournament?.bracket?.events?.[0]?.phases?.[0].numSeeds,
	)

	const fullBracket = mergeRealMatches(
		skeleton,
		tournament?.bracket?.events?.[0]?.phases?.[0]?.phaseGroups?.nodes?.[0]
			?.sets?.nodes,
	)

	useSocketEvent('updateConfig', (newdata) => {
		console.log(`Received updateConfig`, newdata)
		setConfig(newdata)
	})

	return (
		<div className="h-dvh mx-auto">
			<link
				rel="stylesheet"
				type="text/css"
				href={`/themes/${config.cssTheme}`}
			/>
			{fullBracket && (
				<SingleEliminationBracket
					options={{
						style: {
							connectorColor: 'rgb(47, 54, 72)',
							connectorColorHighlight: 'rgb(47, 54, 72)',
							boxHeight: 50,
							spaceBetweenRows: 12,
						},
					}}
					matches={fullBracket}
					matchComponent={Match}
				/>
			)}
		</div>
	)
}

export default BracketDisplay
